export {default} from './Genre';
